import { DestinationFormData } from '@/types/destinationFormData'
import { isValidYyyyMmDdFormat } from '@/utils/dateUtils'
import {
  containsFullWidthAlphaNumeric,
  isHalfWidthNumeric,
  isValidPhoneNumber,
} from '@/utils/inputChecker'

export type ValidationErrors = Partial<
  Record<keyof DestinationFormData | 'postalCode', string>
>

export const useDestinationValidation = () => {
  const validate = (formData: DestinationFormData): ValidationErrors => {
    const newErrors: ValidationErrors = {}

    if (!formData.startDate) {
      newErrors.startDate = '適用開始日は必須です'
    } else if (!isValidYyyyMmDdFormat(formData.startDate)) {
      newErrors.startDate = '適用開始日はYYYY-MM-DD形式で入力してください'
    } else {
      const [year, month, day] = formData.startDate.split('-').map(Number)
      const startDate = new Date(year, month - 1, day)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (startDate < today) {
        newErrors.startDate = '適用開始日は本日以降の日付で入力してください'
      }
    }

    if (!formData.destinationCode) {
      newErrors.destinationCode = '送達先番号は必須です'
    } else if (!isHalfWidthNumeric(formData.destinationCode)) {
      newErrors.destinationCode = '送達先番号は半角数字で入力してください'
    } else if (formData.destinationCode.length > 8) {
      newErrors.destinationCode = '送達先番号は8桁以内で入力してください'
    }
    if (!formData.name) {
      newErrors.name = '送達先名は必須です'
    } else if (formData.name.length > 50) {
      newErrors.name = '送達先名は50文字以内で入力してください'
    }

    if (!formData.prefectureCode) {
      newErrors.prefectureCode = '都道府県は必須です'
    }

    if (!formData.postalCode1 || !formData.postalCode2) {
      newErrors.postalCode = '郵便番号は必須です'
    } else if (
      !isHalfWidthNumeric(formData.postalCode1) ||
      !isHalfWidthNumeric(formData.postalCode2)
    ) {
      newErrors.postalCode = '郵便番号は半角数字で入力してください'
    } else if (formData.postalCode1.length !== 3 || formData.postalCode2.length !== 4) {
      newErrors.postalCode = '郵便番号は3桁-4桁の形式で入力してください'
    }

    if (!formData.addressLine1) {
      newErrors.addressLine1 = '住所１は必須です'
    } else if (formData.addressLine1.length > 50) {
      newErrors.addressLine1 = '住所１は50文字以内で入力してください'
    } else if (containsFullWidthAlphaNumeric(formData.addressLine1)) {
      newErrors.addressLine1 = '住所１の英数字は半角で入力してください'
    }

    if (formData.addressLine2 && formData.addressLine2.length > 50) {
      newErrors.addressLine2 = '住所２は50文字以内で入力してください'
    } else if (
      formData.addressLine2 &&
      containsFullWidthAlphaNumeric(formData.addressLine2)
    ) {
      newErrors.addressLine2 = '住所２の英数字は半角で入力してください'
    }

    if (formData.phoneNumber && !isValidPhoneNumber(formData.phoneNumber)) {
      newErrors.phoneNumber =
        '電話番号は半角数字、ハイフンありで入力してください'
    }
    if (formData.faxNumber && !isValidPhoneNumber(formData.faxNumber)) {
      newErrors.faxNumber = 'FAX番号は半角数字、ハイフンありで入力してください'
    }
    if (
      formData.destinationsPhoneNumber &&
      !isValidPhoneNumber(formData.destinationsPhoneNumber)
    ) {
      newErrors.destinationsPhoneNumber =
        '送達先電話番号は半角数字、ハイフンありで入力してください'
    }

    return newErrors
  }

  return { validate }
}
